export default "__VITE_ASSET__CwxU8wZZ__"